<template>
    <div class="common-item">
        <van-checkbox v-model="innerChecked" v-show="showCheckbox"></van-checkbox>
        <van-image
            :src="imgUrl"
            width="36"
            height="36"
            lazy-load round fit="cover"
        />
        <div class="text">
            <h4 class="title">{{ title }}</h4>
            <p class="desc">{{ desc }}</p>
        </div>
        <van-icon name="arrow"/>
    </div>
</template>

<script>
import {Checkbox, Image} from 'vant'

export default {
    name: 'CommonItem',
    components: {
        [Checkbox.name]: Checkbox,
        [Image.name]: Image,
    },
    props: ['title', 'imgUrl', 'desc', 'checked', 'showCheckbox'],
    data() {
        return {
            innerChecked: this.checked
        }
    },
    computed: {},
    methods: {},
    created() {
    }
}
</script>

<style scoped lang="scss">
@import "~@/assets/css/theme/theme.scss";
.common-item {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    background-color: #ffffff;
    position: relative;

    &:after {
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        right: 16px;
        bottom: 0;
        left: 16px;
        border-bottom: 1px solid #F0F0F0;
        transform: scaleY(0.5);
    }

    & > *:not(:last-child) {
        margin-right: 10px;
    }

    .text {
        flex: 1;

        .title {
            color: #333;
            font-weight: 400;
            margin-bottom: 5px;
            @extend .font14;
        }

        .desc {
            color: #666;
            @extend .font12;
        }
    }
}
</style>
